<section class="users-view" *ngIf="college_data">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7 my-3">
        <div class="media d-flex align-items-center">
          <div *ngIf="!college_data?.image"
                        [class.initial-alpha]="!college_data?.image"
                        class="users-avatar-shadow rounded mr-1 ml-0 bg-p bg-primary"
                      >
                        <div class="avatar-content">
                          {{college_data?.business_id[0]?.name |titlecase| shortName}}
                        </div>
          </div>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{ college_data?.business_id[0]?.name | titlecase}}</span>
              <!-- <span class="text-muted font-medium-1">
                <span>@</span>
                <span class="users-view-username">dean3004</span>
              </span> -->
            </h4>
            
          </div>
        </div>
      </div>
   
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <!-- <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-12 users-module">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          
                          <th>Net Fee</th>
                          <th>Total Paid</th>
                          <th>Paid Fee</th>
                          <th>Pending Fee</th>
                          <th>Mode</th>
                          <th>Status</th>
                          <th>Transaction Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let transaction of transactionData">
                                                  
                          <td>
                            <span>{{ college_data?.net_fees |  currency:'INR':'symbol' }}</span>
                          </td>
                          <td>
                            <span>{{ transaction?.total_paid |  currency:'INR':'symbol' }}</span>
                          </td>
                          <td>
                            <span
                              class="badge bg-light-success"  placement="top"
                              ngbTooltip="{{transaction?.payment_notes}}">{{ transaction?.paid_amount |  currency:'INR':'symbol' }}</span>
                          </td>
                          <td>
                            <span class="badge bg-light-danger" *ngIf="transaction?.pendingAmount !==null">{{ transaction?.pendingAmount |  currency:'INR':'symbol' }}</span>
                            <span class="badge bg-light-danger" *ngIf="transaction?.pendingAmount==null">{{0 |  currency:'INR':'symbol'}}</span>
                          </td>
                          <td>
                            <span>{{ transaction?.mode?.displayname }}</span>
                          </td>
                          <td>
                            <span *ngIf="transaction?.payment_status =='due'" class="badge bg-light-warn">{{ transaction?.payment_status }}</span>
                            <span *ngIf="transaction?.payment_status =='received'" class="badge bg-light-success">{{ transaction?.payment_status }}</span>

                          </td>
                          <td>
                            <span>{{ transaction?.updated_at | date :'mediumDate' }}</span>
                          </td>
                          <td>
                            <i class="ft-edit text-primary cursor-pointer mr-2" (click)="openContent(college_data?._id,transaction?._id)"></i>
                            <i *ngIf="user_role.roles =='admin' || user_type == 'HR'" class="ft-trash-2 text-danger cursor-pointer" (click)="deleteTransaction(transaction?._id)"></i>
                          </td>
                        </tr>
                        <p *ngIf="transactionData.length<1" style="color:red">Data Not Found</p>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                Business Info</h5>
              <div class="col-12" *ngIf="college_data?.business_id[0]?.name">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Name:</td>
                        <td class="users-view-name">
                            <span>{{college_data?.business_id[0]?.name |titlecase}}</span>
                            <span *ngIf="!college_data?.business_id[0]?.name">Data Not Found</span>
                        </td>
                      </tr>
                       <tr>
                        <td>Business Type:</td>
                        <td class="users-view-name">
                            <span>{{college_data?.business_type?.displayname }}</span>
                            <span *ngIf="!college_data?.business_type?.displayname">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>E-mail:</td>
                        <td>
                            <span>{{college_data?.business_id[0]?.email}}</span>
                            <span *ngIf="!college_data?.business_id[0]?.email">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Phone:</td>
                        <td>
                            <span>{{college_data?.business_id[0]?.phone}}</span>
                            <span *ngIf="!college_data?.business_id[0]?.phone">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Address:</td>
                        <td>
                            <span  class="badge bg-light-info">{{college_data?.business_id[0]?.address}}</span>
                            <span *ngIf="!college_data?.business_id[0]?.address">Data Not Found</span>
                        </td>
                      </tr>
                   
                      <tr>
                        <td>About: </td>
                        <td  [innerText]="college_data?.business_id[0]?.about"></td>
                        <td *ngIf="!college_data?.business_id[0]?.about">Data Not Found</td>
                      </tr>
                      <tr>
                        <td>Facebook Url: </td>
                        <td>
                            <span>{{college_data?.business_id[0]?.facebook_url}}</span>
                            <span *ngIf="!college_data?.business_id[0]?.facebook_url">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Linked Url: </td>
                        <td>
                            <span>{{college_data?.business_id[0]?.linked_url}}</span>
                            <span *ngIf="!college_data?.business_id[0]?.linked_url">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Website: </td>
                        <td>
                            <span>{{college_data?.business_id[0]?.website }}</span>
                            <span *ngIf="!college_data?.business_id[0]?.website">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Notes: </td>
                        <td  [innerText]="college_data?.business_id[0]?.notes ">
                        <span *ngIf="!college_data?.business_id[0]?.notes">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Admin Notes: </td>
                        <td [innerText]="college_data?.business_id[0]?.admin_notes">
                        <span *ngIf="!college_data?.business_id[0]?.admin_notes">Data Not Found</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div id="accordion">
                    <ngb-accordion #acc="ngbAccordion">
                      <ngb-panel >
                         <ng-template ngbPanelTitle>
                            Tagging Info 
                            <span *ngIf="college_data?.tagging?.length">
                              ( Total : {{ college_data?.tagging?.length }} )
                            </span>
                          </ng-template> 
                        <ng-template ngbPanelContent>
                          <div class="col-12" *ngIf="college_data?.tagging?.length>0">
                    <div class="card">
                        <div class="card-content">
                            <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-xl-12 users-module">
                                  
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                    <thead>
                                        <tr>
                                        <th>Name</th>
                                        <th>Slug</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let tag of college_data?.tagging">
                                                                
                                        <td>
                                            <span>{{ tag?.displayname }}</span>
                                        </td>
                                        <td>
                                            <span>{{ tag?.slug  }}</span>
                                        </td>
                                        
                                        </tr>
                                        <p *ngIf="college_data?.tagging.length<1" style="color:red">Data Not Found</p>
                                    </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                        </ng-template>
                      </ngb-panel>
                      <ngb-panel>
                         <ng-template ngbPanelTitle>
                            City Info 
                            <span *ngIf="college_data?.city?.length">
                              ( Total : {{ college_data?.city?.length }} )
                            </span>
                          </ng-template> 
                        <ng-template ngbPanelContent>
                           <div class="table-responsive" *ngIf="college_data?.city?.length>0">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>
                            <span>{{college_data?.city[0]?.displayname}}</span>
                            <span *ngIf="!college_data?.city[0]?.displayname">Data Not Found</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                        </ng-template>
                      </ngb-panel>

                           <ngb-panel>
                            <ng-template ngbPanelTitle>
                            Contact Info 
                            <span *ngIf="college_data?.contact?.length">
                              ( Total : {{ college_data?.contact?.length }} )
                            </span>
                          </ng-template> 
              <ng-template ngbPanelContent>
                <div class="row" >
                    <div class="col-12 col-xl-12 users-module" *ngIf="college_data?.contact?.length >0" >
                      <div class="table-responsive">
                        <div>
                          <span>Total : {{college_data?.contact?.length}}</span>
                        </div>
                          <table class="table mb-0">
                          <thead>
                              <tr>
                              
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Type</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let item of college_data?.contact">
                                                      
                              <td>
                                  <span>{{ item?.name }}</span>
                              </td>
                              <td>
                                  <span>{{ item?.email  }}</span>
                              </td>
                              <td>
                                  <span>{{ item?.phone  }}</span>
                              </td>
                              <td>
                                <span>{{item?.type_client?.displayname}}</span>
                              </td>
                              
                              </tr>
                              <p *ngIf="college_data?.contact.length<1" style="color:red">Data Not Found</p>
                          </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
              </ng-template>
            </ngb-panel>

                 <ngb-panel > 
                    <ng-template ngbPanelTitle>
                            Events Info 
                            <span *ngIf="college_data?.event?.length">
                              ( Total : {{ college_data?.event?.length }} )
                            </span>
                          </ng-template> 
                  
              <ng-template ngbPanelContent>
                 <div class="row" >
                    <div class="col-12 col-xl-12 users-module" *ngIf="college_data?.event?.length >0">
                      <div class="table-responsive">
                    
                          <table class="table mb-0">
                          <thead>
                              <tr>
                              
                              <th>Name</th>
                              <th>Notes</th>
                              <th>Location</th>
                              <th>Event Capacity</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let item of college_data?.event">
                                                      
                              <td>
                                  <span>{{ item?.name }}</span>
                              </td>
                              <td>
                                  <span>{{ item?.notes  }}</span>
                              </td>
                              <td>
                                  <span>{{ item?.location  }}</span>
                              </td>
                              <td>
                                <span>{{item?.event_capacity}}</span>
                              </td>
                              
                              </tr>
                              <p *ngIf="college_data?.event.length<1" style="color:red">Data Not Found</p>
                          </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
              </ng-template>
            </ngb-panel>

                 <ngb-panel> 
                  <ng-template ngbPanelTitle>
                            Students Info 
                            <span *ngIf="college_data?.student?.length">
                              ( Total : {{ college_data?.student?.length }} )
                            </span>
                          </ng-template> 
              <ng-template ngbPanelContent>
                <div class="row" *ngIf="college_data?.student?.length >0">
                    <div class="col-12 col-xl-12 users-module">
                      <div class="table-responsive">
                        
                          <table class="table mb-0">
                          <thead>
                              <tr>
                              
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>Notes</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let item of college_data?.student">
                                                      
                              <td>
                                  <span>{{ item?.user[0]?.name }}</span>
                              </td>
                              <td>
                                  <span>{{ item?.user[0]?.email  }}</span>
                              </td>
                              <td>
                                  <span>{{ item?.user[0]?.phone  }}</span>
                              </td>
                              <td>
                                <span>{{item?.user[0]?.notes}}</span>
                              </td>
                              
                              </tr>
                              <p *ngIf="college_data?.student.length<1" style="color:red">Data Not Found</p>
                          </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
              </ng-template>
            </ngb-panel>

              
                    </ngb-accordion>
                </div>

                    
                
                 
                  
                 
               
                  
                  <h5 class="mb-2 text-bold-500" *ngIf="college_data?.students"><i class="ft-info mr-2"></i>
                    Placement Info</h5>
                  <div class="table-responsive" *ngIf="college_data?.students">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Placement Info:</td>
                          <td>
                            <span>{{college_data?.students?.placementinfo}}</span>
                            <span *ngIf="!college_data?.students?.placementinfo">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Placement business:</td>
                          <td>
                            <span>{{college_data?.students?.placement_business?.name}}</span>
                            <span *ngIf="!college_data?.students?.placement_business?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Bio:</td>
                          <td>
                            <span>{{college_data?.students?.bio}}</span>
                            <span *ngIf="!college_data?.students?.bio">Data Not Found</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- User detail ends -->
      </div>
    </div>
   
  </section>
  
<!------------- Project Assign Popup --------------------------------------->
<div>
	<ng-template #myModalProjectAssign>
	  <div class="modal-header">
		<h4 class="modal-title">Project Assign</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Projects</label>
				<ng-select
				[items]="project_list"
				bindLabel="name"
				bindValue="_id"
				[closeOnSelect]="false"
				placeholder="Select Project"
				[(ngModel)]="selected_project"
				[ngModelOptions]="{ standalone: true }"
				(change)="getProjectId($event)"
			  ></ng-select>
			</fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="projectAssign()">Submit</button>
	  </div>
	</ng-template>
</div>